import { Grid } from "@mui/material";
import { useState } from "react";
import AddPageWrapper from "../../components/general/AddPageWrapper";
import TitleBar from "../../components/general/TitleBar";
import MathEditor from "../../components/RichText/MathEditor";
import SectionSubmitRow from "./SectionSubmitRow";
import { TASK_SECTION, isTaskSectionDirty } from "./taskSectionEdit";

const containerStyle = { paddingBottom: 20 };
const editorContainerStyle = { margin: "36px 60px" };

export default function SolutionSection({
  task,
  updateField,
  isReadOnly,
  original,
  isEdit,
  submittingSection,
  onSubmitSection,
}) {
  const [expand, setExpand] = useState(false);

  return (
    <Grid container style={containerStyle}>
      <TitleBar
        title="Task Solution/Working"
        state={expand}
        setState={setExpand}
      />
      {expand && (
        <AddPageWrapper>
          <Grid container style={editorContainerStyle}>
            <Grid item xs={12} style={{ minHeight: 320 }}>
              <MathEditor
                style={{ height: 300 }}
                value={task.solutions ?? ""}
                onChange={
                  isReadOnly
                    ? undefined
                    : (html) => updateField("solutions", html)
                }
                readOnly={isReadOnly}
                placeholder="Solution / working — supports math and images"
              />
            </Grid>
          </Grid>
          {isEdit && original && !isReadOnly && (
            <SectionSubmitRow
              disabled={
                !isTaskSectionDirty(original, task, TASK_SECTION.SOLUTION) ||
                submittingSection !== null
              }
              submitting={submittingSection === TASK_SECTION.SOLUTION}
              onSubmit={() => onSubmitSection(TASK_SECTION.SOLUTION)}
            />
          )}
        </AddPageWrapper>
      )}
    </Grid>
  );
}
